import React from 'react';
import Spinner from '../../Spinner';
import { CardsFound } from './CardsFound';

export const CardFoundWrapper = ({
  loadingGetSecurityList,
  errorGetSecurityList,
  securityList,
}) => {
  if (loadingGetSecurityList) {
    return <Spinner />;
  }

  if (errorGetSecurityList) {
    throw new Error('Error cardFound');
  }

  return (
    <>
      {securityList.map(security => {
        const { Name, Custom } = security;
        const custom = JSON.parse(Custom);
        return (
          <CardsFound
            loadingGetSecurityList={loadingGetSecurityList}
            errorGetSecurityList={errorGetSecurityList}
            securityList={securityList}
            key={security.ID}
            security={security}
            fundName={Name.slice(4)}
            rentabilityFound={custom.fund_details.expected_return}
            typeCurrency={custom.fund_details.currency}
          />
        );
      })}
    </>
  );
};
